// src/config.js

export const BASE_URL = 'https://api.asapstore.shop';
//export const BASE_URL = 'http://localhost:4000';
